

















































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  addQuestionType,
  deleteQuestionType,
  getQuestionTypeList,
  QuestionTypeForm,
  updateQuestionType
} from "@/serve/question/questionType";

interface QuestionTypeQuery {
  current: number;
  size: number;
  typeCode: string;
  typeName: string;
}

@Component({
  name: "TypeManagePage"
})
export default class TypeManagePage extends Vue {
  public form: QuestionTypeQuery = {
    current: 1,
    size: 10,
    typeCode: "",
    typeName: ""
  };

  public ruleForm: QuestionTypeForm = this.emptyForm();
  public tableData: QuestionTypeForm[] = [];
  public total = 0;
  public itemDialog = false;
  public isAdd = true;
  public loading = false;
  public submitLoading = false;

  public get dialogTitle() {
    return this.isAdd ? "新增问卷类型" : "修改问卷类型";
  }

  public created() {
    this.getTableData();
  }

  private emptyForm(): QuestionTypeForm {
    return {
      id: null,
      typeCode: "",
      typeName: "",
      description: "",
      sort: 0
    };
  }

  public search() {
    this.form.current = 1;
    this.getTableData();
  }

  public async getTableData() {
    this.loading = true;
    try {
      const dataItem = { ...this.form };
      const res = await getQuestionTypeList((this as any).$changNull(dataItem));
      if (res.success) {
        this.tableData = res.data.records || [];
        this.total = res.data.total || 0;
      }
    } finally {
      this.loading = false;
    }
  }

  public resetForm() {
    this.form = {
      current: 1,
      size: 10,
      typeCode: "",
      typeName: ""
    };
    this.getTableData();
  }

  public addNew() {
    this.isAdd = true;
    this.ruleForm = {
      ...this.emptyForm(),
      sort: this.total + 1
    };
    this.itemDialog = true;
  }

  public editRow(row: QuestionTypeForm) {
    this.isAdd = false;
    this.ruleForm = { ...row };
    this.itemDialog = true;
  }

  public deleteRow(id: number) {
    (this as any).$messageBox
      .confirm("您确定要删除该问卷类型吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
      .then(async () => {
        const res = await deleteQuestionType(id);
        if (res.success) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getTableData();
        }
      });
  }

  public submitForm(formName: string) {
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (!valid) {
        return false;
      }
      this.submitLoading = true;
      try {
        const submitData = { ...this.ruleForm };
        const res = this.isAdd
          ? await addQuestionType(submitData)
          : await updateQuestionType(submitData);
        if (res.success) {
          this.$message({
            message: res.msg || "保存成功",
            type: "success"
          });
          this.itemDialog = false;
          this.getTableData();
        } else {
          this.showApiMessage(res, "保存失败", "warning");
        }
      } finally {
        this.submitLoading = false;
      }
      return true;
    });
  }

  public handleSizeChange(size: number) {
    this.form.size = size;
    this.form.current = 1;
    this.getTableData();
  }

  public handleCurrentChange(current: number) {
    this.form.current = current;
    this.getTableData();
  }

  public clearValidate() {
    const formRef = this.$refs.ruleForm as any;
    if (formRef) {
      formRef.clearValidate();
    }
  }

  private showApiMessage(res: any, fallback: string, type: "error" | "warning" = "error") {
    if (res && res.__messageShown) {
      return;
    }
    this.$message[type]((res && res.msg) || fallback);
  }

  private rules = {
    typeCode: [
      { required: true, message: "请输入类型编码", trigger: "blur" },
      { min: 1, max: 64, message: "长度在 1 到 64 个字符", trigger: "blur" }
    ],
    typeName: [
      { required: true, message: "请输入类型名称", trigger: "blur" },
      { min: 1, max: 100, message: "长度在 1 到 100 个字符", trigger: "blur" }
    ],
    sort: [{ required: true, message: "请输入排序", trigger: "blur" }]
  };
}
